import { MethodsType, GetSchema } from '@/define';
import { Helper } from '@/methods/base';
import { createMethodRenderer } from '@/methods/renderer';

export class GetHelper extends Helper {
  // 待处理的数据
  constructor(uri: string, method: MethodsType, params: GetSchema) {
    super(uri, method, params);
  }
  // get是没有data的
  generatorDefineData() {
    return {
      key: '',
      propertiesKey: {},
      definitionsKey: {},
    };
  }
}

export const useGetMethdos = (uri: string, method: MethodsType, params: GetSchema, _response?: any) => {
  // GET 请求不包含 data 参数
  return createMethodRenderer(uri, method, params, false);
};
